import { AtkSummaryCard } from "../atk/AtkSummaryCard";
import { FleetView } from "protos/portal/users";
import { getClass, RobotClass } from "common/utils/robots";
import { LaserWeederSummaryCard } from "../laserweeder/LaserWeederSummaryCard";
import { RobotSummaryResponse } from "protos/portal/robots";
import React, { FunctionComponent } from "react";

export interface AnyRobotSummaryCardProps {
  link?: boolean;
  serial: string;
  variant: "freestanding" | "sidebar";
  summary?: RobotSummaryResponse;
  columns?: FleetView["columns"];
}

export const AnyRobotSummaryCard: FunctionComponent<
  AnyRobotSummaryCardProps
> = (props) => {
  const robotClass = getClass(props.serial);

  switch (robotClass) {
    case RobotClass.Buds:
    case RobotClass.Slayers:
    case RobotClass.Reapers: {
      return <LaserWeederSummaryCard {...props} />;
    }
    case RobotClass.Rtcs: {
      return <AtkSummaryCard {...props} />;
    }
    default: {
      // currently, if a robot summary card represents a robot which is in one
      // of the "weird" robot classes, and is being displayed in a context
      // which contains both laserweeders and ATKs (i.e., basically just the
      // fleet view in "cards" mode, and mission control view), we just assume
      // it's a LaserWeeder for historical compatibility.  at some point we may
      // want to revisit this decision but for now, just live with it.
      return <LaserWeederSummaryCard {...props} />;
    }
  }
};
